import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import Auth from './Auth';

function handleErrors(response) {
  return new Promise(function (resolve, reject) {
    if (!response.ok) {
      return reject(response);
    } // TODO handle better delete empty 204 responses


    if (response.status === 204) {
      return resolve();
    }

    return response.json().then(resolve).catch(reject);
  });
}

function getHeaders() {
  var isJSON = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var headers = {
    'browser-id': '551a8593cede18b4199eec32'
  };

  if (isJSON) {
    headers['Content-Type'] = 'application/json';
  }

  if (Auth.getToken()) {
    headers.Authorization = Auth.getAuthorizationHeader();
  }

  return headers;
}

var Fetch =
/*#__PURE__*/
function () {
  function Fetch() {
    _classCallCheck(this, Fetch);
  }

  _createClass(Fetch, null, [{
    key: "getJSON",
    value: function getJSON(url) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$headers = _ref.headers,
          headers = _ref$headers === void 0 ? {} : _ref$headers,
          signal = _ref.signal;

      return fetch(url, {
        headers: _extends({}, getHeaders(), headers),
        signal: signal
      }).then(handleErrors);
    }
  }, {
    key: "get",
    value: function get(url) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$headers = _ref2.headers,
          headers = _ref2$headers === void 0 ? {} : _ref2$headers,
          signal = _ref2.signal;

      return fetch(url, {
        headers: _extends({}, getHeaders(false), headers),
        signal: signal
      }).then(handleErrors);
    }
  }, {
    key: "postJSON",
    value: function postJSON(url, data) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref3$headers = _ref3.headers,
          headers = _ref3$headers === void 0 ? {} : _ref3$headers,
          signal = _ref3.signal;

      return fetch(url, {
        method: 'POST',
        headers: _extends({}, getHeaders(), headers),
        body: JSON.stringify(data),
        signal: signal
      }).then(handleErrors);
    }
  }, {
    key: "post",
    value: function post(url, data) {
      var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref4$headers = _ref4.headers,
          headers = _ref4$headers === void 0 ? {} : _ref4$headers,
          signal = _ref4.signal;

      return fetch(url, {
        method: 'POST',
        headers: _extends({}, getHeaders(false), headers),
        body: data,
        signal: signal
      }).then(handleErrors);
    }
  }, {
    key: "putJSON",
    value: function putJSON(url, data) {
      var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref5$headers = _ref5.headers,
          headers = _ref5$headers === void 0 ? {} : _ref5$headers,
          signal = _ref5.signal;

      return fetch(url, {
        method: 'PUT',
        headers: _extends({}, getHeaders(), headers),
        body: JSON.stringify(data),
        signal: signal
      }).then(handleErrors);
    }
  }, {
    key: "put",
    value: function put(url, data) {
      var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref6$headers = _ref6.headers,
          headers = _ref6$headers === void 0 ? {} : _ref6$headers,
          signal = _ref6.signal;

      return fetch(url, {
        method: 'PUT',
        headers: _extends({}, getHeaders(false), headers),
        body: data,
        signal: signal
      }).then(handleErrors);
    }
  }, {
    key: "patchJSON",
    value: function patchJSON(url, data) {
      var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref7$headers = _ref7.headers,
          headers = _ref7$headers === void 0 ? {} : _ref7$headers,
          signal = _ref7.signal;

      return fetch(url, {
        method: 'PATCH',
        headers: _extends({}, getHeaders(), headers),
        body: JSON.stringify(data),
        signal: signal
      }).then(handleErrors);
    }
  }, {
    key: "patch",
    value: function patch(url, data) {
      var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref8$headers = _ref8.headers,
          headers = _ref8$headers === void 0 ? {} : _ref8$headers,
          signal = _ref8.signal;

      return fetch(url, {
        method: 'PATCH',
        headers: _extends({}, getHeaders(false), headers),
        body: data,
        signal: signal
      }).then(handleErrors);
    }
  }, {
    key: "deleteJSON",
    value: function deleteJSON(url, data) {
      var _ref9 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref9$headers = _ref9.headers,
          headers = _ref9$headers === void 0 ? {} : _ref9$headers,
          signal = _ref9.signal;

      return fetch(url, {
        method: 'DELETE',
        headers: _extends({}, getHeaders(), headers),
        body: JSON.stringify(data),
        signal: signal
      }).then(handleErrors);
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref10$headers = _ref10.headers,
          headers = _ref10$headers === void 0 ? {} : _ref10$headers,
          signal = _ref10.signal;

      return fetch(url, {
        method: 'DELETE',
        headers: _extends({}, getHeaders(false), headers),
        signal: signal
      }).then(handleErrors);
    }
  }]);

  return Fetch;
}();

export default Fetch;